import { AutoMap } from "@automapper/classes"
import { EElimsAggregatedStatus } from "./enums/elims-aggregate-status"

export class ELIMSJobInfo {
    @AutoMap()
    Status: EElimsAggregatedStatus = EElimsAggregatedStatus.AllJobsPending
    @AutoMap()
    LastError: string = ''
    get HasError() {
        return this.Status === EElimsAggregatedStatus.ElimsBatchError ||
            this.Status === EElimsAggregatedStatus.FinalizedIntercoError ||
            this.Status === EElimsAggregatedStatus.RegisteredSampleError ||
            this.Status === EElimsAggregatedStatus.ValidatedResultError
    }

    get IsPending() {
        return this.Status === EElimsAggregatedStatus.ElimsBatchCompleted ||
        this.Status === EElimsAggregatedStatus.RegisteredSampleCompleted ||
        this.Status === EElimsAggregatedStatus.ValidatedResultCompleted
    }
}